
import { Injectable } from '@angular/core';

import { App } from '../../types/admon/app.type';
import { BaseDataSource } from '../shared/_base.datasource';
import { CompanyOperatorService } from '../../../services/admon/operator.service';
import { OperatorCompany } from '../../types/admon/OperatorCompany.type';
import { Observable } from 'rxjs';

@Injectable()
export class CompanyOperatorDatasource extends BaseDataSource<App> {
  constructor(private service: CompanyOperatorService) {
    super(service);
  }

  getList(companyId?: number) {
    const self = this;

    if (!self.service) {
      return;
    }

    self.loading = true;

    self.service.getList(self.filter, companyId).subscribe(res => {
      self.collectionList.next(res.rows);
      self.rows = res.rows;
      self.count = res.count;
      self.loading = false;
    });
  }
}
